/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-05-05 01:25:47
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Page, TextStyle, Banner, Stack, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';

import { routes } from 'src/routes';
import history from 'src/routes/history';
import { URL } from 'src/constants/links';

import SendRequestModal from 'src/components/containers/common/send-request-modal';

import * as OauthAction from 'actions/oauth-actions';
import * as AppPermissionActions from 'actions/app-permission-actions';

type Props = {
  success: boolean,
  accessScopes: Object,
  updateScopes: Function,
  updateAppScopes: Function
};

type ComposedProps = Props & WithI18nProps;

type State = {
  activeRequest: boolean
};

class AnalyticsThemeV1PermissionSuccess extends Component<ComposedProps, State> {
  state = {
    // Modal send request
    activeRequest: false
  };

  componentDidMount() {
    const { updateScopes } = this.props;
    updateScopes();
  }

  componentWillReceiveProps(nextProps) {
    const { success, updateAppScopes } = this.props;
    const { success: successNext, accessScopes } = nextProps;

    // Update successfully
    if (successNext === true && success === false) {
      // Update tenant app scopes in state
      updateAppScopes(accessScopes);
    }
  }

  render() {
    const { i18n } = this.props;
    const { activeRequest } = this.state;

    return (
      <div className="BC-Page BC-Page_Success">
        <Page
          title={i18n.translate('AdminHTML.AppPermission.AnalyticsV1PermissionSuccess.pageTitle')}
          breadcrumbs={[
            {
              content: i18n.translate(
                'AdminHTML.AppPermission.AnalyticsV1PermissionSuccess.redirectTitle'
              ),
              onAction: () => {
                history.push({ pathname: routes.analytics.view(), state: { selectedTab: 2 } });
              }
            }
          ]}>
          <Banner
            title={i18n.translate(
              'AdminHTML.AppPermission.AnalyticsV1PermissionSuccess.bannerTitle'
            )}
            status="success"
            action={{
              content: i18n.translate(
                'AdminHTML.AppPermission.AnalyticsV1PermissionSuccess.buttonChildren'
              ),
              onAction: () => {
                history.push({ pathname: routes.analytics.view(), state: { selectedTab: 2 } });
              }
            }}>
            <Stack vertical={true}>
              <TextStyle>
                {i18n.translate('AdminHTML.AppPermission.AnalyticsV1PermissionSuccess.content01', {
                  t1: (
                    <Link external url={URL['AnalyticsDoc']}>
                      {i18n.translate(
                        'AdminHTML.AppPermission.AnalyticsV1PermissionSuccess.content01_t1'
                      )}
                    </Link>
                  )
                })}
              </TextStyle>
              <TextStyle>
                {i18n.translate('AdminHTML.AppPermission.AnalyticsV1PermissionSuccess.content02', {
                  t1: (
                    <Link onClick={() => this.toggleModal('activeRequest')}>
                      {i18n.translate(
                        'AdminHTML.AppPermission.AnalyticsV1PermissionSuccess.content02_t1'
                      )}
                    </Link>
                  )
                })}
              </TextStyle>
            </Stack>
          </Banner>
        </Page>
        <SendRequestModal
          active={activeRequest}
          handleChange={() => this.toggleModal('activeRequest')}
        />
      </div>
    );
  }

  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateScopes: () => dispatch(AppPermissionActions.updateScopes(ownProps.i18n)),
  updateAppScopes: accessScopes => dispatch(OauthAction.updateAppScopes(accessScopes))
});

const mapStateToProps = (state, props) => ({
  success: _.get(state.appPermission, 'success', false),
  accessScopes: _.get(state.appPermission, 'accessScopes', {})
});

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(AnalyticsThemeV1PermissionSuccess)
);
